import React from "react";
import style from "./QuestTianKong.module.scss";

interface QuestTianKongProps {
    index: number;
    correct: boolean;
    trunk: string;
    answers: {
        answerId: number;
        content: string;
        isRight: "0" | "1";
        isChoose: "0" | "1";
        stuAnswer: string;
    }[];
}

export default function QuestTianKong({
    index,
    correct,
    trunk,
    answers
}: QuestTianKongProps) {
    return (
        <div className={style.root}>
            <div className={style.content}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: `${index + 1}.${trunk}`
                    }}
                />
            </div>

            <div className={style.answerGroup}>
                {answers.map((item, index) => (
                    <div className={style.answer} key={item.answerId}>
                        <div>
                            {index + 1}. {item.stuAnswer}
                        </div>
                        <div>正确答案：{item.content}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
